export default __webpack_public_path__ + "static/media/slider1.91b3f159.jpg";